import React, { useContext, useEffect, useState } from "react";
import { FiAlignLeft } from "react-icons/fi";
import { FiSearch } from "react-icons/fi";
import { FiShoppingCart } from "react-icons/fi";
import { FiHeart } from "react-icons/fi";
import { FiUser } from "react-icons/fi";
import Search from "./Shared/Search";
import { IoHomeOutline } from "react-icons/io5";
// import { BsShop } from "react-icons/bs";
import { GiClothes } from "react-icons/gi";
import { Link } from "react-router-dom";
import { RxCrossCircled } from "react-icons/rx";
import Cart from "../pages/Cart";
import { AiFillHeart } from "react-icons/ai";
import { AiOutlineHeart } from "react-icons/ai";
import WishList from "../pages/WishList";
import Login from "./Auth/Login";
import LoginPage from "../pages/LoginPage";
import { ProductContext } from "../contexts/ProductContext";

function Navbar() {
  const { cartOpen, isWishlistOpen, setCartOpen, setIsWishlistOpen } =
    useContext(ProductContext);

  const [isHovered, setIsHovered] = useState({ svg1: false, svg2: false });
  const [isScrolled, setIsScrolled] = useState(false);
  const [showSearchbar, setShowSearchbar] = useState(false);
  // const [isCartOpen, setIsCartOpen] = useState(cartOpen);
  // const [isWishListOpen, setIsWishListOpen] = useState(isWishlistOpen);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      if (scrollPosition > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const hideSearchBar = (value) => {
    setShowSearchbar(value);
  };

  // const hideCart = (value) => {
  //   setCartOpen(value)
  //   setIsCartOpen(value);
  // };

  // const hideWishlist = (value) => {
  //   setIsWishlistOpen(value)
  //   setIsWishListOpen(value);
  // };

  return (
    <header className="">
      <div
        style={{ letterSpacing: "2px" }}
        className="flex md:flex-row flex-col justify-center items-center gap-1 bg-primarybg p-3 font-primaryFont font-semibold text-[9px] text-white md:text-[15px] discount-Nav"
      >
        <span className="">FLAT 10% OFF ON YOUR 1ST APP PURCHASE</span>
        <span className="underline uppercase">Download App</span>
      </div>

      {/* Top navbar */}
      <nav
        className={`${
          isScrolled
            ? "fixed top-0 w-full bg-white shadow-md md:shadow-none z-50"
            : "relative"
        }`}
      >
        <div className="z-50 flex justify-between items-center px-5 p-3 border-b-[1px] container">
          <div className="logo">
            <Link to={`/`}>
              {" "}
              <img
                className="w-28 md:w-40 cursor-pointer"
                src="https://www.snitch.co.in/cdn/shop/files/blackoption.png?v=1659016547"
                alt=""
              />
            </Link>
          </div>
          <div className="flex justify-between gap-2 md:gap-4 item-center text-2xl md:text-3xl tabs">
            <Link to={`/`}>
              {" "}
              <span className="cursor-pointer search">
                <IoHomeOutline className="text-iconcolor hover:text-black" />
              </span>
            </Link>
            <Link to={`/products`}>
              <span className="cursor-pointer search">
                <GiClothes className="text-iconcolor hover:text-black" />
              </span>
            </Link>
            <span
              className="cursor-pointer search"
              onClick={() => setShowSearchbar(!showSearchbar)}
            >
              {showSearchbar ? (
                <RxCrossCircled className="text-iconcolor hover:text-black" />
              ) : (
                <FiSearch className="text-iconcolor hover:text-black" />
              )}
            </span>
            <div
              className="md:block hidden cursor-pointer wishList"
              onClick={() => setIsWishlistOpen(true)}
            >
              <AiOutlineHeart className="text-iconcolor hover:text-black" />
            </div>
            <span
              className="cursor-pointer cart"
              onClick={() => setCartOpen(true)}
            >
              <FiShoppingCart className="text-iconcolor hover:text-black" />
            </span>
            {/* <div className="md:hidden humsburge">
              <FiAlignLeft className="text-3xl text-iconcolor hover:text-black cursor-pointer" />
            </div> */}
            <div className="md:block hidden cursor-pointer account">
              <Link to={`/login`}>
                {" "}
                <FiUser className="text-iconcolor hover:text-black" />{" "}
              </Link>
            </div>

          </div>
        </div>
      </nav>

      {/* bottom navbar */}
      <nav id="bottom-nav" className="md:hidden">
        <div className="bottom-0 z-50 fixed flex justify-around items-center gap-2 bg-white shadow-top py-2 w-full">
          <div className="account">
            {/* <GoogleLogin 
              onSuccess={(credentialResponse) => {
                const credential = jwtDecode(
                  credentialResponse.credential
                );
                console.log(credential);
              }}
              onError={() => {
                console.log("Login Failed");
              }
            }
            /> */}
            {/* <FiUser
        className="text-2xl text-iconcolor hover:text-black cursor-pointer"
      /> */}
            <Link to={`/login`}>
              {" "}
              <FiUser className="text-2xl text-iconcolor hover:text-black cursor-pointer" />{" "}
            </Link>
          </div>
          <div
            className="flex justify-center items-center cursor-pointer wishList"
            onClick={() => setIsWishlistOpen(true)}
          >
            <AiOutlineHeart className="text-2xl text-iconcolor hover:text-black cursor-pointer" />
            {/* <svg
              xmlns="http://www.w3.org/2000/svg"
              className="m-0 p-0 pt-1 w-10"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="1"
              stroke={isHovered.svg1 ? "black" : "gray"}
              onMouseEnter={() => setIsHovered({ ...isHovered, svg1: true })}
              onMouseLeave={() => setIsHovered({ ...isHovered, svg1: false })}
      
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M9.813 15.904L9 18.75l-.813-2.846a4.5 4.5 0 00-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 003.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 003.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 00-3.09 3.09zM18.259 8.715L18 9.75l-.259-1.035a3.375 3.375 0 00-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 002.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 002.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 00-2.456 2.456zM16.894 20.567L16.5 21.75l-.394-1.183a2.25 2.25 0 00-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 001.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 001.423 1.423l1.183.394-1.183.394a2.25 2.25 0 00-1.423 1.423z"
              />
            </svg> */}
          </div>
          <div className="flex justify-center items-center cursor-pointer collections">
            <Link to={`/products`}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="m-0 p-0 pt-2 w-10"
                version="1.1"
                x="0px"
                y="0px"
                viewBox="0 0 96 120"
                enableBackground="new 0 0 96 96"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                xmlSpace="preserve"
                strokeWidth="1"
                stroke={isHovered.svg2 ? "black" : "gray"}
                onMouseEnter={() => setIsHovered({ ...isHovered, svg2: true })}
                onMouseLeave={() => setIsHovered({ ...isHovered, svg2: false })}
              >
                <g>
                  <path d="M49.235,8v38.764H88V8H49.235z M86.096,44.859H51.14V9.905h34.956V44.859z" />
                  <path d="M8,46.764h38.765V8H8V46.764z M9.905,9.905H44.86v34.955H9.905V9.905z" />
                  <path d="M8,88h38.765V49.237H8V88z M9.905,51.142H44.86v34.954H9.905V51.142z" />
                  <path d="M49.235,88H88V49.237H49.235V88z M51.14,51.142h34.956v34.954H51.14V51.142z" />
                </g>
              </svg>
            </Link>
          </div>
          <div className="cart" onClick={() => setCartOpen(true)}>
            <FiShoppingCart className="text-2xl text-iconcolor hover:text-black cursor-pointer" />
          </div>
          <div
            className="search"
            onClick={() => setShowSearchbar(!showSearchbar)}
          >
            {showSearchbar ? (
              <RxCrossCircled className="text-2xl text-iconcolor hover:text-black cursor-pointer" />
            ) : (
              <FiSearch className="text-2xl text-iconcolor hover:text-black cursor-pointer" />
            )}
          </div>
        </div>
      </nav>

      {/* Search Container */}
      {showSearchbar && (
        <Search showSearchbar={showSearchbar} hideSearchBar={hideSearchBar} />
      )}

      {/* show cart */}
      {cartOpen && <Cart />}
      {/* {isCartOpen && <Cart hideCart={hideCart} />} */}

      {/* show Wishlist */}
      {isWishlistOpen && <WishList />}
      {/* {isWishListOpen && <WishList hideWishlist={hideWishlist} />} */}
    </header>
  );
}

export default Navbar;
